import Images from "@/assets/images";
import Image from "next/image";

export const hamburger = [
  {
    icon: (
      <svg
        width="21"
        height="15"
        viewBox="0 0 28 20"
        fill="none"
        className="hamburuer"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 18.3333C0 19.2538 0.746191 20 1.66667 20H12.3333C13.2538 20 14 19.2538 14 18.3333C14 17.4129 13.2538 16.6667 12.3333 16.6667H1.66667C0.746191 16.6667 0 17.4129 0 18.3333ZM0 10C0 10.9205 0.746191 11.6667 1.66667 11.6667H26.3333C27.2538 11.6667 28 10.9205 28 10C28 9.07952 27.2538 8.33333 26.3333 8.33333H1.66667C0.746193 8.33333 0 9.07952 0 10ZM0 1.66667C0 2.58714 0.746191 3.33333 1.66667 3.33333H26.3333C27.2538 3.33333 28 2.58714 28 1.66667C28 0.746192 27.2538 0 26.3333 0L1.66667 0C0.746193 0 0 0.746192 0 1.66667Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
];

export const mainItems = [
  {
    icon: (
      <svg
        width="21"
        height="15"
        viewBox="0 0 28 20"
        fill="none"
        className="hamburuer"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 18.3333C0 19.2538 0.746191 20 1.66667 20H12.3333C13.2538 20 14 19.2538 14 18.3333C14 17.4129 13.2538 16.6667 12.3333 16.6667H1.66667C0.746191 16.6667 0 17.4129 0 18.3333ZM0 10C0 10.9205 0.746191 11.6667 1.66667 11.6667H26.3333C27.2538 11.6667 28 10.9205 28 10C28 9.07952 27.2538 8.33333 26.3333 8.33333H1.66667C0.746193 8.33333 0 9.07952 0 10ZM0 1.66667C0 2.58714 0.746191 3.33333 1.66667 3.33333H26.3333C27.2538 3.33333 28 2.58714 28 1.66667C28 0.746192 27.2538 0 26.3333 0L1.66667 0C0.746193 0 0 0.746192 0 1.66667Z"
          fill="currentColor"
        />
      </svg>
    ),
    id: "msp-home",
    title: "",
    subtitle: "",
    path: null,
  },
  {
    icon: (
      <svg
        width="28"
        height="27"
        viewBox="0 0 28 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          d="M27.4205 13.1638L14.6986 0.392491C14.607 0.300287 14.4982 0.227136 14.3784 0.177225C14.2586 0.127314 14.1302 0.101624 14.0006 0.101624C13.8709 0.101624 13.7425 0.127314 13.6227 0.177225C13.503 0.227136 13.3942 0.300287 13.3026 0.392491L0.580655 13.1638C0.210024 13.5362 0 14.042 0 14.5694C0 15.6648 0.886425 16.5553 1.9767 16.5553H3.31715V25.6684C3.31715 26.2176 3.75881 26.6613 4.30549 26.6613H12.0239V19.7109H15.4831V26.6613H23.6957C24.2423 26.6613 24.684 26.2176 24.684 25.6684V16.5553H26.0245C26.5495 16.5553 27.053 16.3474 27.4236 15.9719C28.1926 15.1962 28.1926 13.9396 27.4205 13.1638Z"
          fill="currentColor"
        />
      </svg>
    ),
    id: "msp-home",
    title: "Home",
    subtitle: "Home",
    path: "/",
  },
  {
    icon: (
      <svg
        width="27px"
        height="27px"
        viewBox="0 0 39 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          d="M7.63608 4.25H1.16484C0.571647 4.25 0.0863037 4.72812 0.0863037 5.3125V28.6875C0.0863037 29.2719 0.571647 29.75 1.16484 29.75H7.63608C8.22928 29.75 8.71462 29.2719 8.71462 28.6875V5.3125C8.71462 4.72812 8.22928 4.25 7.63608 4.25ZM6.55754 10.625H2.24338V8.5H6.55754V10.625ZM18.4215 4.25H11.9502C11.357 4.25 10.8717 4.72812 10.8717 5.3125V28.6875C10.8717 29.2719 11.357 29.75 11.9502 29.75H18.4215C19.0147 29.75 19.5 29.2719 19.5 28.6875V5.3125C19.5 4.72812 19.0147 4.25 18.4215 4.25ZM17.3429 10.625H13.0288V8.5H17.3429V10.625Z"
          fill="currentColor"
        />
        <path
          d="M25.872 5.89282L20.0932 8.76157C19.8387 8.88904 19.6456 9.11038 19.5559 9.37742C19.4662 9.64446 19.4872 9.93559 19.6144 10.1874L29.3212 29.1637C29.4506 29.4144 29.6753 29.6047 29.9464 29.693C30.2174 29.7814 30.5129 29.7607 30.7686 29.6354L36.5474 26.7667C36.8019 26.6392 36.9951 26.4179 37.0847 26.1508C37.1744 25.8838 37.1534 25.5927 37.0263 25.3408L27.3194 6.36457C27.19 6.11383 26.9654 5.92359 26.6943 5.83524C26.4232 5.74689 26.1277 5.76758 25.872 5.89282Z"
          fill="currentColor"
        />
        <path
          d="M31.364 28.6875C31.364 28.9693 31.2504 29.2395 31.0481 29.4388C30.8458 29.6381 30.5715 29.75 30.2854 29.75C29.9994 29.75 29.7251 29.6381 29.5228 29.4388C29.3205 29.2395 29.2069 28.9693 29.2069 28.6875C29.2069 28.4057 29.3205 28.1355 29.5228 27.9362C29.7251 27.7369 29.9994 27.625 30.2854 27.625C30.5715 27.625 30.8458 27.7369 31.0481 27.9362C31.2504 28.1355 31.364 28.4057 31.364 28.6875Z"
          fill="currentColor"
        />
      </svg>
    ),
    id: "msp-courses",
    title: "Courses",
    subtitle: "Courses",
    path: "/courses",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27px"
        height="27px"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M12 3L1 9l11 6l9-4.91V17h2V9M5 13.18v4L12 21l7-3.82v-4L12 17z"
        />
      </svg>
    ),
    id: "msp-batches",
    title: "Batches",
    subtitle: "Batches",
    path: "/batches",
    type: "new",
  },
  {
    icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        className="sidebar-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M3.92229 8.45268C4.35113 8.88305 4.67364 9.40753 4.86416 9.98443L5.48016 11.8778C5.53166 12.0238 5.62716 12.1501 5.75349 12.2395C5.87982 12.3289 6.03078 12.3769 6.18554 12.3769C6.3403 12.3769 6.49125 12.3289 6.61758 12.2395C6.74392 12.1501 6.83942 12.0238 6.89091 11.8778L7.50691 9.98443C7.6989 9.40909 8.02228 8.88637 8.4514 8.45772C8.88053 8.02908 9.4036 7.70628 9.97916 7.51493L11.8739 6.89893C12.0194 6.84715 12.1453 6.75162 12.2343 6.62545C12.3233 6.49928 12.3711 6.34866 12.3711 6.19425C12.3711 6.03984 12.3233 5.88921 12.2343 5.76304C12.1453 5.63687 12.0194 5.54134 11.8739 5.48956L11.8354 5.47993L9.94066 4.86393C9.3651 4.67258 8.84203 4.34979 8.4129 3.92114C7.98378 3.4925 7.6604 2.96978 7.46841 2.39443L6.85379 0.501059C6.80258 0.354641 6.70712 0.227764 6.58062 0.137994C6.45412 0.0482232 6.30284 0 6.14772 0C5.99261 0 5.84133 0.0482232 5.71483 0.137994C5.58833 0.227764 5.49287 0.354641 5.44166 0.501059L4.82566 2.39443L4.81054 2.44118C4.61787 3.00219 4.29994 3.51193 3.88086 3.93172C3.46179 4.35151 2.95259 4.67031 2.39191 4.86393L0.497162 5.47993C0.351693 5.53171 0.225814 5.62724 0.1368 5.75342C0.047786 5.87959 0 6.03021 0 6.18462C0 6.33903 0.047786 6.48966 0.1368 6.61583C0.225814 6.742 0.351693 6.83753 0.497162 6.88931L2.39191 7.50531C2.96941 7.69781 3.49191 8.02231 3.92229 8.45268ZM24.748 6.87693C25.1127 6.87693 25.4624 7.0218 25.7203 7.27966C25.9782 7.53752 26.123 7.88726 26.123 8.25193V15.1269C26.123 15.4916 25.9782 15.8413 25.7203 16.0992C25.4624 16.3571 25.1127 16.5019 24.748 16.5019C24.3834 16.5019 24.0336 16.3571 23.7758 16.0992C23.5179 15.8413 23.373 15.4916 23.373 15.1269V11.5712L15.4077 19.5366C15.1498 19.7943 14.8001 19.9391 14.4355 19.9391C14.0709 19.9391 13.7213 19.7943 13.4634 19.5366L10.998 17.0712L3.72016 24.3491C3.46083 24.5995 3.11351 24.7381 2.75299 24.735C2.39246 24.7319 2.0476 24.5872 1.79266 24.3323C1.53773 24.0774 1.39312 23.7325 1.38999 23.372C1.38685 23.0115 1.52544 22.6641 1.77591 22.4048L10.0259 14.1548C10.2838 13.897 10.6334 13.7522 10.998 13.7522C11.3626 13.7522 11.7123 13.897 11.9702 14.1548L14.4355 16.6202L21.4288 9.62693H17.873C17.5084 9.62693 17.1586 9.48207 16.9008 9.22421C16.6429 8.96634 16.498 8.61661 16.498 8.25193C16.498 7.88726 16.6429 7.53752 16.9008 7.27966C17.1586 7.0218 17.5084 6.87693 17.873 6.87693H24.748ZM24.7714 21.9538L25.8247 22.2948L25.8453 22.3003C25.9059 22.3217 25.9608 22.3569 26.0056 22.403C26.0504 22.4492 26.0839 22.5051 26.1035 22.5663C26.123 22.6276 26.1282 22.6926 26.1184 22.7562C26.1087 22.8197 26.0844 22.8802 26.0474 22.9328C25.9975 23.0031 25.9268 23.056 25.8453 23.0841L24.7934 23.4251C24.4733 23.5315 24.1824 23.7111 23.9437 23.9495C23.7051 24.188 23.5252 24.4787 23.4184 24.7987L23.0774 25.8492C23.0489 25.9304 22.9959 26.0008 22.9257 26.0506C22.8555 26.1003 22.7716 26.1271 22.6855 26.1271C22.5995 26.1271 22.5155 26.1003 22.4453 26.0506C22.3751 26.0008 22.3221 25.9304 22.2937 25.8492L21.9513 24.7987C21.8452 24.4781 21.6658 24.1866 21.4273 23.9474C21.1889 23.7083 20.898 23.528 20.5777 23.4209L19.5258 23.0786C19.4651 23.0571 19.4103 23.022 19.3655 22.9758C19.3207 22.9297 19.2872 22.8738 19.2676 22.8125C19.248 22.7512 19.2429 22.6863 19.2526 22.6227C19.2624 22.5591 19.2867 22.4987 19.3237 22.4461C19.3736 22.3758 19.4443 22.3229 19.5258 22.2948L20.5777 21.9538C20.8935 21.8446 21.18 21.6639 21.4146 21.4259C21.6493 21.1879 21.8259 20.899 21.9307 20.5816L22.273 19.5297C22.3015 19.4485 22.3545 19.3781 22.4247 19.3283C22.4949 19.2785 22.5788 19.2518 22.6649 19.2518C22.751 19.2518 22.8349 19.2785 22.9051 19.3283C22.9753 19.3781 23.0283 19.4485 23.0568 19.5297L23.3992 20.5802C23.5058 20.9 23.6855 21.1907 23.9239 21.4291C24.1623 21.6675 24.4516 21.8471 24.7714 21.9538Z"
        />
      </svg>
    ),
    id: "msp-trending",
    title: "Trending",
    subtitle: "Trending",
    path: "/trending-courses",
  },
  {
    icon: (
      <svg
        width="28"
        height="25"
        viewBox="0 0 28 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          d="M0 21.886C0.0717424 21.4673 0.139572 21.0486 0.217184 20.6312C0.95287 16.6925 3.95431 13.5776 7.89166 12.7838C10.8918 12.1786 13.6311 12.8223 16.0631 14.7118C16.1049 14.7444 16.1427 14.7835 16.1988 14.8344C15.4324 15.9738 15.0131 17.2253 14.9785 18.595C14.9439 19.9646 15.2942 21.2207 16.0305 22.4475L0 22.4873V21.886Z"
          fill="currentColor"
        />
        <path
          d="M15.8792 18.7587C15.8922 15.3633 18.6185 12.6736 22.0601 12.7101C25.4751 12.746 28.0552 15.5766 27.9991 18.8689C27.9443 22.1364 25.2096 24.8496 21.9121 24.8294C18.5826 24.8085 15.8668 22.0751 15.8792 18.7587ZM20.9664 19.6183C20.5405 19.122 20.1407 18.6498 19.7331 18.1834C19.51 17.9291 19.2491 17.8978 19.0424 18.083C18.8526 18.2532 18.8519 18.535 19.0496 18.7665C19.5387 19.3435 20.0305 19.9172 20.5248 20.4877C20.7492 20.7486 20.9625 20.7668 21.2377 20.5529C21.5129 20.339 21.7901 20.1061 22.0654 19.8818C22.955 19.1578 23.8446 18.4332 24.7342 17.708C25.0107 17.483 25.0635 17.2221 24.8855 17.0036C24.7074 16.7851 24.4446 16.7929 24.1635 17.0153C24.0207 17.1282 23.8811 17.2456 23.7396 17.3604L20.9664 19.6183Z"
          fill="currentColor"
        />
        <path
          d="M9.90762 1.48281e-05C10.6669 -0.000243383 11.4188 0.149234 12.1202 0.439891C12.8216 0.730548 13.4588 1.15668 13.9954 1.69389C14.5319 2.23111 14.9573 2.86886 15.2471 3.57065C15.5368 4.27244 15.6854 5.02449 15.6842 5.78376C15.679 8.97956 13.0754 11.5538 9.85675 11.546C6.7053 11.5382 4.12388 8.94173 4.11736 5.77463C4.11475 2.58992 6.71769 -0.00715941 9.90762 1.48281e-05Z"
          fill="currentColor"
        />
      </svg>
    ),
    id: "msp-following",
    title: "Followings",
    subtitle: "Followings",
    path: "/followings",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25px"
        height="25px"
        viewBox="0 0 128 128"
      >
        <path
          fill="#f5b03e"
          d="M16.4 31.73s-6.45.51-7.31 1.96c-.87 1.45-.92 3.68-.92 6.13c0 2.46-.1 8.1-.1 8.1l1.54 3.31s.29 42.19.29 43.5c0 1.3 0 2.89 1.88 3.9c1.88 1.01 49.66 24.09 51.15 24.71c2.25.93 3.32.58 3.32.58l53.09-88.79s-.17-2.43-2.38-3.01c-1.27-.32-100.56-.39-100.56-.39"
        />
        <path
          fill="#e07f14"
          d="M65.68 60.92c-.81 2.23-.44 25.29-.3 42.06c.14 16.76-.43 20.23 0 20.81c.43.58 1.6.02 4.91-1.45c6.15-2.72 35.69-17.34 37.86-18.64c2.17-1.3 7.47-3.99 8.34-5.44s1.34-14.94 1.63-25.77c.29-10.84.58-19.51.58-19.51l1.3-3.9s-.28-10.54-.33-11.7c-.09-1.92-.3-2.91-.79-2.67c-.7.33-6.54 5.12-22 12.64c-9.71 4.71-30.64 12.03-31.2 13.57"
        />
        <path
          fill="#fdd717"
          d="M65.82 11.21c-4.33-.2-16.18 6.65-27.6 10.4S9.56 32.9 9.41 33.34c-.14.43 6.94 3.6 11.46 5.77c5.37 2.57 25.87 12.28 29.62 13.87c3.76 1.59 12.72 5.31 14.16 5.2c2.02-.14 21.1-7.66 30.78-12.28s21.78-11.78 21.94-13.52c.07-.78-17.8-7.45-26.71-11.48c-17.2-7.79-21.67-9.54-24.84-9.69"
        />
        <path
          fill="#e37d14"
          d="M8.12 49.77c.15 1.88 1.18 2.55 3.8 3.69c2.62 1.14 52.15 26.87 53.29 26.87c1.14 0 1.48-4.08.23-3.97c-.68.06-16.95-7.67-32.15-15.39C20.39 54.43 8.04 47.9 8.04 47.9z"
        />
        <path
          fill="#ba5e0d"
          d="M120.01 48.99S67.12 75.89 66.6 76.15s-1.35.17-1.35.17l-.04 4.01s.49.11 1.04-.06c.32-.1 52.23-26.97 52.46-27.05s1.23-.68 1.44-1.95c.18-1.02-.14-2.28-.14-2.28"
        />
        <path
          fill="#af0f1b"
          d="m28.86 97.42l10.35 15.4l4.53 1.55s.37-16.8.52-29.25c.21-18.19.13-34.78.39-35.72c.43-1.59 20.56-8.12 20.56-8.12S87.95 48.41 88.67 50c.32.7.07 12.48 0 26.21c-.09 17.34-.06 37.36-.06 37.36s2.35-.01 2.63-.88c.29-.87 1.45-7.58 1.45-7.58l8.82-58.79l4.48-5.78l-6.22-11.84l-25.52-12.56l-8.77 1.97l-9.49-1.45l-30.1 21.63l3.51 7.12l8.61 4.39z"
        />
        <path
          fill="#dc0d28"
          d="M91.28 49.39c-.55 1.21-.23 63.56-.23 63.56s2.75-1.52 6.29-3.22c3.52-1.69 6.05-2.74 6.27-3.62s.61-62.54.61-62.54z"
        />
        <path
          fill="#ff2a23"
          d="M41.35 48.1c.33.36-.21 65.06-.88 65.21c-.53.13-12.58-5.25-12.58-5.8c0-.55.97-62.38.97-62.38S40.37 47 41.35 48.1m23.88-33.85c-3.33 0-7.01.95-8.08 3.74s-1.31 6.94-1.31 10.04c0 2.97-.48 10.57 8.67 10.45c9.15-.12 9.42-3.51 9.56-10.99c.12-6.24-.71-9.27-1.54-10.57c-.74-1.17-3.2-2.67-7.3-2.67"
        />
        <path
          fill="#fcc9d2"
          d="M59.94 29.69c2.08.12 2.97-4.45 4.57-6.95c1.6-2.49 3.27-4.16 2.67-5.46c-.49-1.08-4.84-1.43-7.19 1.84c-1.65 2.31-1.94 10.46-.05 10.57"
        />
        <path
          fill="#ff2a23"
          d="M73.33 16.42s2.95 3 3.72 8.88s-.12 10.45-.12 10.45s14.66-.44 19.72.53c4.99.97 6.73 3.17 6.73 4.77c0 1.6-3.28 2.89-6.61 2.65s-5.58-.42-6 .42s.18 2.14 4.81 2.49c4.63.36 9.98-.3 11.64-6.06s1.72-15.74 1.13-22.93c-.59-7.19-1.89-11.3-5.11-12.86c-3.39-1.63-11.88-1.9-19.9 2.61s-10.01 9.05-10.01 9.05"
        />
        <path
          fill="#fcc9d2"
          d="M89.94 9.58c-1.04-1.34-4.39-1.3-6.18.77c-1.9 2.2-2.32 10.57.12 11.05c2.76.54 2.26-3.98 4.28-6.77c1.98-2.73 2.79-3.74 1.78-5.05"
        />
        <path
          fill="#ff2a23"
          d="M56.38 16.71S45.15 3.62 32.32 3.82c-7.72.12-9.68 4.57-10.1 6.41s-3.62 20.14.65 30.05S36 47.62 37.39 47.3c1.78-.42 5.57-1.72 5.21-3.09c-.36-1.37-12.95 3.56-13.07-2.08s8.91-6.24 13.07-6.36c4.16-.12 11.29.83 11.29.83s-1.25-6.83-.42-11.7s2.91-8.19 2.91-8.19"
        />
        <path
          fill="#fcc9d2"
          d="M28.88 8.57c-1.6 1.66-2.26 11.23-1.25 15.98s1.9 6.77 3.98 6.36c1.74-.35 2.79-9.67 3.62-12.95c.89-3.5 3.09-7.22 2.2-8.85c-1.36-2.5-6.88-2.27-8.55-.54"
        />
      </svg>
    ),
    // type: "new",
    id: "msp-gift",
    title: "Rewards Store",
    subtitle: "Rewards",
    path: "/rewards/cipherpoints",
  },
  {
    icon: (
      <svg
        width="22"
        height="25"
        viewBox="0 0 24 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.656 9.296C1.95158 9.296 1.27602 9.01617 0.777924 8.51807C0.279828 8.01998 0 7.34441 0 6.64V2.656C0 1.95158 0.279828 1.27602 0.777924 0.777924C1.27602 0.279828 1.95158 0 2.656 0H7.968C8.67241 0 9.34798 0.279828 9.84608 0.777924C10.3442 1.27602 10.624 1.95158 10.624 2.656V6.64C10.624 7.34441 10.3442 8.01998 9.84608 8.51807C9.34798 9.01617 8.67241 9.296 7.968 9.296H2.656ZM2.656 26.56C1.95158 26.56 1.27602 26.2802 0.777924 25.7821C0.279828 25.284 0 24.6084 0 23.904V13.28C0 12.5756 0.279828 11.9 0.777924 11.4019C1.27602 10.9038 1.95158 10.624 2.656 10.624H7.968C8.67241 10.624 9.34798 10.9038 9.84608 11.4019C10.3442 11.9 10.624 12.5756 10.624 13.28V23.904C10.624 24.6084 10.3442 25.284 9.84608 25.7821C9.34798 26.2802 8.67241 26.56 7.968 26.56H2.656ZM15.936 26.56C15.2316 26.56 14.556 26.2802 14.0579 25.7821C13.5598 25.284 13.28 24.6084 13.28 23.904V21.248C13.28 20.5436 13.5598 19.868 14.0579 19.3699C14.556 18.8718 15.2316 18.592 15.936 18.592H21.248C21.9524 18.592 22.628 18.8718 23.1261 19.3699C23.6242 19.868 23.904 20.5436 23.904 21.248V23.904C23.904 24.6084 23.6242 25.284 23.1261 25.7821C22.628 26.2802 21.9524 26.56 21.248 26.56H15.936ZM15.936 15.936C15.2316 15.936 14.556 15.6562 14.0579 15.1581C13.5598 14.66 13.28 13.9844 13.28 13.28V2.656C13.28 1.95158 13.5598 1.27602 14.0579 0.777924C14.556 0.279828 15.2316 0 15.936 0H21.248C21.9524 0 22.628 0.279828 23.1261 0.777924C23.6242 1.27602 23.904 1.95158 23.904 2.656V13.28C23.904 13.9844 23.6242 14.66 23.1261 15.1581C22.628 15.6562 21.9524 15.936 21.248 15.936H15.936Z"
          fill="currentColor"
        />
      </svg>
    ),
    id: "msp-p-dashboard",
    title: "Dashboard",
    subtitle: "Dashboard",
    path: "/profile",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30px"
        height="30px"
        viewBox="0 0 256 256"
      >
        <path
          fill="currentColor"
          d="M216 40H40a16 16 0 0 0-16 16v144a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16M92.8 145.6a8 8 0 1 1-9.6 12.8l-32-24a8 8 0 0 1 0-12.8l32-24a8 8 0 0 1 9.6 12.8L69.33 128Zm58.89-71.4l-32 112a8 8 0 1 1-15.38-4.4l32-112a8 8 0 0 1 15.38 4.4m53.11 60.2l-32 24a8 8 0 0 1-9.6-12.8l23.47-17.6l-23.47-17.6a8 8 0 1 1 9.6-12.8l32 24a8 8 0 0 1 0 12.8"
        />
      </svg>
    ),
    id: "msp-code-editor",
    title: "Code Compiler",
    subtitle: "Compiler",
    path: "https://compiler.cipherschools.com",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M0 5.368A6.01 6.01 0 0 1 5.58 0a.6.6 0 0 0-.093.093a10.13 10.13 0 0 0-2.209 5.275zM3.652 8.91q0 .066.005.131v2.496A6.01 6.01 0 0 1 0 6.618h3.278c.073.66.21 1.31.41 1.939a2 2 0 0 0-.036.352Zm.885-2.29h1.75l-1.58.684l-.051.023a9 9 0 0 1-.12-.708Zm7.41-1.25H8.665A10.13 10.13 0 0 0 6.457.092A.6.6 0 0 0 6.363 0a6.01 6.01 0 0 1 5.584 5.368Zm-7.41 0h2.87a8.9 8.9 0 0 0-1.435-3.831a8.9 8.9 0 0 0-1.435 3.83ZM9.65 6.71a.55.55 0 0 0-.434 0L5.242 8.432a.6.6 0 0 0-.116.068a.68.68 0 0 0-.349.596v3.028a.682.682 0 0 0 1.365 0v-2.3l3.074 1.331c.139.06.296.06.434 0l3.974-1.721a.546.546 0 0 0 0-1.002zm-2.933 4.51l2.024.877a1.74 1.74 0 0 0 1.383 0l2.024-.877v1.358c0 .12-.038.236-.11.33l-.435-.33l.434.331l-.001.002l-.002.002l-.004.006l-.012.015a2 2 0 0 1-.165.176c-.11.104-.27.237-.483.368c-.431.264-1.071.514-1.937.514s-1.506-.25-1.936-.515a3 3 0 0 1-.61-.5l-.037-.044l-.012-.015l-.004-.006l-.002-.002v-.002H6.83l.435-.33l-.435.33a.55.55 0 0 1-.11-.329l-.004-1.36Z"
          clip-rule="evenodd"
        />
      </svg>
    ),
    id: "msp-stp",
    title: "STP",
    subtitle: "STP",
    path: "https://www.cs.cipherschools.com/",
  },
  {
    icon: (
      <svg
        width="30"
        height="24"
        viewBox="0 0 28 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        id="resume"
      >
        <path
          opacity="0.2"
          d="M6.125 1.75H17.8238C18.1877 1.74984 18.5477 1.82537 18.8809 1.97179C19.2141 2.1182 19.5132 2.3323 19.7593 2.6005L27.3088 10.829C27.7532 11.3131 27.9998 11.9463 28 12.6035V30.625C28 31.3212 27.7234 31.9889 27.2312 32.4812C26.7389 32.9734 26.0712 33.25 25.375 33.25H6.125C5.42881 33.25 4.76113 32.9734 4.26884 32.4812C3.77656 31.9889 3.5 31.3212 3.5 30.625V4.375C3.5 3.67881 3.77656 3.01113 4.26884 2.51885C4.76113 2.02656 5.42881 1.75 6.125 1.75Z"
          fill="#FFA103"
        />
        <path
          d="M6.125 20.125C5.89294 20.125 5.67038 20.0328 5.50628 19.8687C5.34219 19.7046 5.25 19.4821 5.25 19.25C5.25 19.0179 5.34219 18.7954 5.50628 18.6313C5.67038 18.4672 5.89294 18.375 6.125 18.375H18.375C18.6071 18.375 18.8296 18.4672 18.9937 18.6313C19.1578 18.7954 19.25 19.0179 19.25 19.25C19.25 19.4821 19.1578 19.7046 18.9937 19.8687C18.8296 20.0328 18.6071 20.125 18.375 20.125H6.125ZM6.125 24.5C5.89294 24.5 5.67038 24.4078 5.50628 24.2437C5.34219 24.0796 5.25 23.8571 5.25 23.625C5.25 23.3929 5.34219 23.1704 5.50628 23.0063C5.67038 22.8422 5.89294 22.75 6.125 22.75H18.375C18.6071 22.75 18.8296 22.8422 18.9937 23.0063C19.1578 23.1704 19.25 23.3929 19.25 23.625C19.25 23.8571 19.1578 24.0796 18.9937 24.2437C18.8296 24.4078 18.6071 24.5 18.375 24.5H6.125Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3238 2.44548e-07H2.625C1.92881 2.44548e-07 1.26113 0.276562 0.768845 0.768845C0.276562 1.26113 0 1.92881 0 2.625V28.875C0 29.5712 0.276562 30.2389 0.768845 30.7312C1.26113 31.2234 1.92881 31.5 2.625 31.5H21.875C22.5712 31.5 23.2389 31.2234 23.7312 30.7312C24.2234 30.2389 24.5 29.5712 24.5 28.875V10.8535C24.4998 10.1963 24.2532 9.56312 23.8088 9.079L16.2593 0.8505C16.0132 0.582305 15.7141 0.368201 15.3809 0.221786C15.0477 0.0753703 14.6877 -0.000156846 14.3238 2.44548e-07ZM1.75 2.625C1.75 2.39294 1.84219 2.17038 2.00628 2.00628C2.17038 1.84219 2.39294 1.75 2.625 1.75H14.3238C14.4452 1.74987 14.5653 1.775 14.6765 1.82381C14.7876 1.87262 14.8874 1.94403 14.9695 2.0335L22.519 10.262C22.6674 10.4233 22.7498 10.6344 22.75 10.8535V28.875C22.75 29.1071 22.6578 29.3296 22.4937 29.4937C22.3296 29.6578 22.1071 29.75 21.875 29.75H2.625C2.39294 29.75 2.17038 29.6578 2.00628 29.4937C1.84219 29.3296 1.75 29.1071 1.75 28.875V2.625Z"
          fill="currentColor"
        />
        <path
          d="M14.875 1.9248V10.1498H23.1"
          stroke="currentColor"
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.98453 8.98265C9.23444 8.9903 9.48333 8.94769 9.71646 8.85734C9.94958 8.76699 10.1622 8.63074 10.3417 8.45667C10.5211 8.28261 10.6638 8.07427 10.7613 7.84402C10.8587 7.61377 10.9089 7.3663 10.9089 7.11627C10.9089 6.86625 10.8587 6.61878 10.7613 6.38853C10.6638 6.15827 10.5211 5.94994 10.3417 5.77587C10.1622 5.60181 9.94958 5.46556 9.71646 5.37521C9.48333 5.28486 9.23444 5.24225 8.98453 5.2499C8.49943 5.26475 8.03917 5.4679 7.70129 5.81629C7.3634 6.16469 7.17444 6.63095 7.17444 7.11627C7.17444 7.6016 7.3634 8.06786 7.70129 8.41625C8.03917 8.76465 8.49943 8.96779 8.98453 8.98265Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7155 13.0272C12.7155 11.0427 11.0443 9.60596 8.98275 9.60596C6.92125 9.60596 5.25 11.041 5.25 13.0272V13.9617C5.25046 14.1266 5.3163 14.2846 5.43309 14.4011C5.54987 14.5176 5.70807 14.583 5.873 14.583H12.0943C12.2589 14.5825 12.4166 14.5169 12.533 14.4005C12.6494 14.2841 12.715 14.1263 12.7155 13.9617V13.0272Z"
          fill="currentColor"
        />
      </svg>
    ),
    id: "msp-resume-builder",
    title: "Resume Builder",
    subtitle: "Resume",
    path: "/resume-builder",
  },
  {
    icon: (
      <svg
        width="28"
        height="27"
        viewBox="0 0 28 27"
        fill="none"
        className="sidebar-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.6667 20C25.3739 20 26.0522 19.719 26.5523 19.219C27.0524 18.7189 27.3333 18.0406 27.3333 17.3333V2.66667C27.3333 1.95942 27.0524 1.28115 26.5523 0.781048C26.0522 0.280951 25.3739 0 24.6667 0H10.6133C11.08 0.813333 11.3333 1.73333 11.3333 2.66667H24.6667V17.3333H12.6667V20M18 6.66667V9.33333H10V26.6667H7.33333V18.6667H4.66667V26.6667H2V16H0V9.33333C0 8.62609 0.280951 7.94781 0.781048 7.44771C1.28115 6.94762 1.95942 6.66667 2.66667 6.66667H18ZM8.66667 2.66667C8.66667 3.37391 8.38572 4.05219 7.88562 4.55228C7.38552 5.05238 6.70724 5.33333 6 5.33333C5.29276 5.33333 4.61448 5.05238 4.11438 4.55228C3.61428 4.05219 3.33333 3.37391 3.33333 2.66667C3.33333 1.95942 3.61428 1.28115 4.11438 0.781048C4.61448 0.280951 5.29276 0 6 0C6.70724 0 7.38552 0.280951 7.88562 0.781048C8.38572 1.28115 8.66667 1.95942 8.66667 2.66667Z"
          fill="currentColor"
        />
      </svg>
    ),
    id: "msp-creator-access",
    title: "Creator Access",
    subtitle: "Creator",
    path: null,
  },
  // {
  //   icon: (
  //     <Image
  //       src={Images.Plutonn}
  //       alt="plutonn-img"
  //       width="25px"
  //       height="25px"
  //     />
  //   ),
  //   id: "msp-plutonn",
  //   title: "Plutonn",
  //   subtitle: "Plutonn",
  //   path: "https://www.plutonn.com",
  // },
  {
    icon: (
      <svg
        width="29"
        height="27"
        viewBox="0 0 29 27"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          d="M18.1875 0C17.6239 0 17.0834 0.223883 16.6849 0.622398C16.2864 1.02091 16.0625 1.56141 16.0625 2.125V6.375C16.0625 6.93859 16.2864 7.47909 16.6849 7.8776C17.0834 8.27612 17.6239 8.5 18.1875 8.5V11.6875L22.0125 8.5H26.6875C27.2511 8.5 27.7916 8.27612 28.1901 7.8776C28.5886 7.47909 28.8125 6.93859 28.8125 6.375V2.125C28.8125 1.56141 28.5886 1.02091 28.1901 0.622398C27.7916 0.223883 27.2511 0 26.6875 0H18.1875ZM8.625 5.3125C7.49783 5.3125 6.41683 5.76027 5.6198 6.5573C4.82277 7.35433 4.375 8.43533 4.375 9.5625C4.375 10.6897 4.82277 11.7707 5.6198 12.5677C6.41683 13.3647 7.49783 13.8125 8.625 13.8125C9.75217 13.8125 10.8332 13.3647 11.6302 12.5677C12.4272 11.7707 12.875 10.6897 12.875 9.5625C12.875 8.43533 12.4272 7.35433 11.6302 6.5573C10.8332 5.76027 9.75217 5.3125 8.625 5.3125ZM13.9375 15.9375H3.3125C2.46712 15.9375 1.65637 16.2733 1.0586 16.8711C0.460825 17.4689 0.125 18.2796 0.125 19.125C0.125 21.4965 1.10037 23.3962 2.7005 24.6819C4.27512 25.9462 6.38737 26.5625 8.625 26.5625C10.8626 26.5625 12.9749 25.9462 14.5495 24.6819C16.1475 23.3962 17.125 21.4965 17.125 19.125C17.125 18.2796 16.7892 17.4689 16.1914 16.8711C15.5936 16.2733 14.7829 15.9375 13.9375 15.9375Z"
          fill="currentColor"
        />
      </svg>
    ),
    id: "msp-send-feed",
    title: "Send Feedback",
    subtitle: "Feedback",
    path: null,
  },
  // {
  //   icon: (
  //     <svg
  //       version="1.1"
  //       xmlns="http://www.w3.org/2000/svg"
  //       viewBox="0 0 250.93 250.93"
  //       width="23"
  //       height="20"
  //       fill="currentColor"
  //     >
  //       <path d="m247.896,25.718l-25.083-17.244c-1.167-0.802-2.55-1.232-3.966-1.232h-91.706c-3.866,0-7,3.134-7,7v47.462h-88.06c-1.416,0-2.799,0.43-3.966,1.231l-25.081,17.244c-1.899,1.306-3.034,3.464-3.034,5.769s1.135,4.462 3.034,5.768l25.082,17.244c1.167,0.802 2.55,1.232 3.966,1.232h88.06v119.496h-29.224c-3.866,0-7,3.134-7,7s3.134,7 7,7h69.74c3.866,0 7-3.134 7-7s-3.134-7-7-7h-26.517v-173.959h84.706c1.416,1.42109e-14 2.799-0.43 3.966-1.232l25.082-17.243c1.899-1.306 3.034-3.463 3.034-5.769s-1.134-4.462-3.033-5.767zm-213.64,70.474l-14.9-10.244 14.9-10.244h85.885v20.488h-85.885zm182.417-54.463h-82.532v-20.487h82.532l14.9,10.244-14.9,10.243z" />
  //     </svg>
  //   ),
  //   id: "msp-site-tour",
  //   title: "Site Tour",
  //   subtitle: "Tour",
  // },
];

export const profile = [
  {
    icon: (
      <svg
        width="15"
        height="27"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="point-icon"
          d="M8.60338 10.0373C11.464 10.0373 13.622 7.87927 13.622 5.01864C13.622 2.15802 11.464 0 8.60338 0C5.74276 0 3.58474 2.15802 3.58474 5.01864C3.58474 7.87927 5.74276 10.0373 8.60338 10.0373ZM10.0373 11.3966H7.16949C3.21623 11.3966 0 14.6128 0 18.5661V20H17.2068V18.5661C17.2068 14.6128 13.9905 11.3966 10.0373 11.3966Z"
          fill="currentColor"
        />
      </svg>
    ),
    title: "My Profile",
    subtitle: "My Profile",
    path: "/profile/me",
  },
];

//Mobile And Tablet View
export const profileItems = [
  {
    icon: (
      <svg
        width="24"
        height="27"
        viewBox="0 0 24 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.656 9.296C1.95158 9.296 1.27602 9.01617 0.777924 8.51807C0.279828 8.01998 0 7.34441 0 6.64V2.656C0 1.95158 0.279828 1.27602 0.777924 0.777924C1.27602 0.279828 1.95158 0 2.656 0H7.968C8.67241 0 9.34798 0.279828 9.84608 0.777924C10.3442 1.27602 10.624 1.95158 10.624 2.656V6.64C10.624 7.34441 10.3442 8.01998 9.84608 8.51807C9.34798 9.01617 8.67241 9.296 7.968 9.296H2.656ZM2.656 26.56C1.95158 26.56 1.27602 26.2802 0.777924 25.7821C0.279828 25.284 0 24.6084 0 23.904V13.28C0 12.5756 0.279828 11.9 0.777924 11.4019C1.27602 10.9038 1.95158 10.624 2.656 10.624H7.968C8.67241 10.624 9.34798 10.9038 9.84608 11.4019C10.3442 11.9 10.624 12.5756 10.624 13.28V23.904C10.624 24.6084 10.3442 25.284 9.84608 25.7821C9.34798 26.2802 8.67241 26.56 7.968 26.56H2.656ZM15.936 26.56C15.2316 26.56 14.556 26.2802 14.0579 25.7821C13.5598 25.284 13.28 24.6084 13.28 23.904V21.248C13.28 20.5436 13.5598 19.868 14.0579 19.3699C14.556 18.8718 15.2316 18.592 15.936 18.592H21.248C21.9524 18.592 22.628 18.8718 23.1261 19.3699C23.6242 19.868 23.904 20.5436 23.904 21.248V23.904C23.904 24.6084 23.6242 25.284 23.1261 25.7821C22.628 26.2802 21.9524 26.56 21.248 26.56H15.936ZM15.936 15.936C15.2316 15.936 14.556 15.6562 14.0579 15.1581C13.5598 14.66 13.28 13.9844 13.28 13.28V2.656C13.28 1.95158 13.5598 1.27602 14.0579 0.777924C14.556 0.279828 15.2316 0 15.936 0H21.248C21.9524 0 22.628 0.279828 23.1261 0.777924C23.6242 1.27602 23.904 1.95158 23.904 2.656V13.28C23.904 13.9844 23.6242 14.66 23.1261 15.1581C22.628 15.6562 21.9524 15.936 21.248 15.936H15.936Z"
          fill="currentColor"
        />
      </svg>
    ),
    title: "Dashboard",
    path: "/profile",
  },
  {
    icon: (
      <svg
        width="24"
        height="27"
        fill="none"
        viewBox="0 0 34 34"
        className="sidebar-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3333 9.91667C11.3333 8.41377 11.9304 6.97243 12.9931 5.90973C14.0558 4.84702 15.4971 4.25 17 4.25C18.5029 4.25 19.9442 4.84702 21.0069 5.90973C22.0696 6.97243 22.6667 8.41377 22.6667 9.91667C22.6667 11.4196 22.0696 12.8609 21.0069 13.9236C19.9442 14.9863 18.5029 15.5833 17 15.5833C15.4971 15.5833 14.0558 14.9863 12.9931 13.9236C11.9304 12.8609 11.3333 11.4196 11.3333 9.91667ZM11.3333 18.4167C9.45472 18.4167 7.65304 19.1629 6.32466 20.4913C4.99628 21.8197 4.25 23.6214 4.25 25.5C4.25 26.6272 4.69777 27.7082 5.4948 28.5052C6.29183 29.3022 7.37283 29.75 8.5 29.75H25.5C26.6272 29.75 27.7082 29.3022 28.5052 28.5052C29.3022 27.7082 29.75 26.6272 29.75 25.5C29.75 23.6214 29.0037 21.8197 27.6753 20.4913C26.347 19.1629 24.5453 18.4167 22.6667 18.4167H11.3333Z"
          fill="currentColor"
        />
      </svg>
    ),
    title: "My Profile",
    path: "/profile/me",
  },
  {
    icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 39 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          d="M7.63572 4.25H1.16448C0.57128 4.25 0.0859375 4.72812 0.0859375 5.3125V28.6875C0.0859375 29.2719 0.57128 29.75 1.16448 29.75H7.63572C8.22891 29.75 8.71426 29.2719 8.71426 28.6875V5.3125C8.71426 4.72812 8.22891 4.25 7.63572 4.25ZM6.55718 10.625H2.24302V8.5H6.55718V10.625ZM18.4211 4.25H11.9499C11.3567 4.25 10.8713 4.72812 10.8713 5.3125V28.6875C10.8713 29.2719 11.3567 29.75 11.9499 29.75H18.4211C19.0143 29.75 19.4997 29.2719 19.4997 28.6875V5.3125C19.4997 4.72812 19.0143 4.25 18.4211 4.25ZM17.3426 10.625H13.0284V8.5H17.3426V10.625Z"
          fill="currentColor"
        />
        <path
          d="M25.8719 5.89257L20.0931 8.76132C19.8386 8.88879 19.6455 9.11013 19.5558 9.37717C19.4661 9.64421 19.4871 9.93534 19.6142 10.1872L29.3211 29.1635C29.4505 29.4142 29.6752 29.6044 29.9462 29.6928C30.2173 29.7811 30.5128 29.7604 30.7685 29.6352L36.5473 26.7664C36.8018 26.639 36.9949 26.4176 37.0846 26.1506C37.1743 25.8836 37.1533 25.5924 37.0262 25.3406L27.3193 6.36432C27.1899 6.11359 26.9652 5.92335 26.6942 5.835C26.4231 5.74665 26.1276 5.76734 25.8719 5.89257Z"
          fill="currentColor"
        />
      </svg>
    ),
    title: "Enrolled Courses",
    path: "/profile/enrollments",
  },
  {
    icon: (
      <svg
        width="28"
        height="25"
        viewBox="0 0 28 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          d="M0 21.886C0.0717424 21.4673 0.139572 21.0486 0.217184 20.6312C0.95287 16.6925 3.95431 13.5776 7.89166 12.7838C10.8918 12.1786 13.6311 12.8223 16.0631 14.7118C16.1049 14.7444 16.1427 14.7835 16.1988 14.8344C15.4324 15.9738 15.0131 17.2253 14.9785 18.595C14.9439 19.9646 15.2942 21.2207 16.0305 22.4475L0 22.4873V21.886Z"
          fill="currentColor"
        />
        <path
          d="M15.8792 18.7587C15.8922 15.3633 18.6185 12.6736 22.0601 12.7101C25.4751 12.746 28.0552 15.5766 27.9991 18.8689C27.9443 22.1364 25.2096 24.8496 21.9121 24.8294C18.5826 24.8085 15.8668 22.0751 15.8792 18.7587ZM20.9664 19.6183C20.5405 19.122 20.1407 18.6498 19.7331 18.1834C19.51 17.9291 19.2491 17.8978 19.0424 18.083C18.8526 18.2532 18.8519 18.535 19.0496 18.7665C19.5387 19.3435 20.0305 19.9172 20.5248 20.4877C20.7492 20.7486 20.9625 20.7668 21.2377 20.5529C21.5129 20.339 21.7901 20.1061 22.0654 19.8818C22.955 19.1578 23.8446 18.4332 24.7342 17.708C25.0107 17.483 25.0635 17.2221 24.8855 17.0036C24.7074 16.7851 24.4446 16.7929 24.1635 17.0153C24.0207 17.1282 23.8811 17.2456 23.7396 17.3604L20.9664 19.6183Z"
          fill="currentColor"
        />
        <path
          d="M9.90762 1.48281e-05C10.6669 -0.000243383 11.4188 0.149234 12.1202 0.439891C12.8216 0.730548 13.4588 1.15668 13.9954 1.69389C14.5319 2.23111 14.9573 2.86886 15.2471 3.57065C15.5368 4.27244 15.6854 5.02449 15.6842 5.78376C15.679 8.97956 13.0754 11.5538 9.85675 11.546C6.7053 11.5382 4.12388 8.94173 4.11736 5.77463C4.11475 2.58992 6.71769 -0.00715941 9.90762 1.48281e-05Z"
          fill="currentColor"
        />
      </svg>
    ),
    title: "Following",
    subtitle: "Following",
    path: "/following",
  },
  {
    icon: (
      <svg
        width="22"
        height="25"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="c-logo"
      >
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke="currentColor"
          className="point-icon"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 16L12.586 13.586C12.2109 13.211 12.0001 12.7024 12 12.172V6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: "My Cipher Point",
    path: null,
  },
  {
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          d="M0.0830078 25.75V0.25H19.9163V25.75L9.99967 21.5L0.0830078 25.75Z"
          fill="currentColor"
        />
      </svg>
    ),
    title: "Wishlist",
    path: "/profile/wishlist",
  },
  {
    icon: (
      <svg
        width="22"
        height="27"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          d="M32.5837 14.1667C32.5837 13.4153 32.2851 12.6946 31.7538 12.1633C31.2224 11.6319 30.5018 11.3334 29.7503 11.3334H20.797L22.157 4.85925C22.1853 4.71758 22.1995 4.56175 22.1995 4.40591C22.1995 3.82508 21.9587 3.28675 21.5762 2.90425L20.0745 1.41675L10.7528 10.7384C10.2287 11.2626 9.91699 11.9709 9.91699 12.7501V26.9167C9.91699 27.6682 10.2155 28.3889 10.7469 28.9202C11.2782 29.4516 11.9989 29.7501 12.7503 29.7501H25.5003C26.6762 29.7501 27.682 29.0417 28.107 28.0218L32.3853 18.0342C32.5128 17.7084 32.5837 17.3684 32.5837 17.0001V14.1667ZM1.41699 29.7501H7.08366V12.7501H1.41699V29.7501Z"
          fill="currentColor"
        />
      </svg>
    ),
    title: "Liked Videos",
    path: "/profile/liked-videos",
  },
];

export const bottomNavItems = [
  {
    icon: (
      <svg
        width="28"
        height="27"
        viewBox="0 0 28 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          d="M27.4205 13.1638L14.6986 0.392491C14.607 0.300287 14.4982 0.227136 14.3784 0.177225C14.2586 0.127314 14.1302 0.101624 14.0006 0.101624C13.8709 0.101624 13.7425 0.127314 13.6227 0.177225C13.503 0.227136 13.3942 0.300287 13.3026 0.392491L0.580655 13.1638C0.210024 13.5362 0 14.042 0 14.5694C0 15.6648 0.886425 16.5553 1.9767 16.5553H3.31715V25.6684C3.31715 26.2176 3.75881 26.6613 4.30549 26.6613H12.0239V19.7109H15.4831V26.6613H23.6957C24.2423 26.6613 24.684 26.2176 24.684 25.6684V16.5553H26.0245C26.5495 16.5553 27.053 16.3474 27.4236 15.9719C28.1926 15.1962 28.1926 13.9396 27.4205 13.1638Z"
          fill="currentColor"
        />
      </svg>
    ),
    id: "msp-home",
    title: "Home",
    subtitle: "Home",
    path: "/",
    path2: "/",
  },
  {
    icon: (
      <svg
        width="27px"
        height="27px"
        viewBox="0 0 39 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          d="M7.63608 4.25H1.16484C0.571647 4.25 0.0863037 4.72812 0.0863037 5.3125V28.6875C0.0863037 29.2719 0.571647 29.75 1.16484 29.75H7.63608C8.22928 29.75 8.71462 29.2719 8.71462 28.6875V5.3125C8.71462 4.72812 8.22928 4.25 7.63608 4.25ZM6.55754 10.625H2.24338V8.5H6.55754V10.625ZM18.4215 4.25H11.9502C11.357 4.25 10.8717 4.72812 10.8717 5.3125V28.6875C10.8717 29.2719 11.357 29.75 11.9502 29.75H18.4215C19.0147 29.75 19.5 29.2719 19.5 28.6875V5.3125C19.5 4.72812 19.0147 4.25 18.4215 4.25ZM17.3429 10.625H13.0288V8.5H17.3429V10.625Z"
          fill="currentColor"
        />
        <path
          d="M25.872 5.89282L20.0932 8.76157C19.8387 8.88904 19.6456 9.11038 19.5559 9.37742C19.4662 9.64446 19.4872 9.93559 19.6144 10.1874L29.3212 29.1637C29.4506 29.4144 29.6753 29.6047 29.9464 29.693C30.2174 29.7814 30.5129 29.7607 30.7686 29.6354L36.5474 26.7667C36.8019 26.6392 36.9951 26.4179 37.0847 26.1508C37.1744 25.8838 37.1534 25.5927 37.0263 25.3408L27.3194 6.36457C27.19 6.11383 26.9654 5.92359 26.6943 5.83524C26.4232 5.74689 26.1277 5.76758 25.872 5.89282Z"
          fill="currentColor"
        />
        <path
          d="M31.364 28.6875C31.364 28.9693 31.2504 29.2395 31.0481 29.4388C30.8458 29.6381 30.5715 29.75 30.2854 29.75C29.9994 29.75 29.7251 29.6381 29.5228 29.4388C29.3205 29.2395 29.2069 28.9693 29.2069 28.6875C29.2069 28.4057 29.3205 28.1355 29.5228 27.9362C29.7251 27.7369 29.9994 27.625 30.2854 27.625C30.5715 27.625 30.8458 27.7369 31.0481 27.9362C31.2504 28.1355 31.364 28.4057 31.364 28.6875Z"
          fill="currentColor"
        />
      </svg>
    ),
    key: "courses",
    id: "msp-courses",
    title: "Courses",
    subtitle: "Courses",
    path: "/courses",
  },
  {
    icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        className="sidebar-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M3.92229 8.45268C4.35113 8.88305 4.67364 9.40753 4.86416 9.98443L5.48016 11.8778C5.53166 12.0238 5.62716 12.1501 5.75349 12.2395C5.87982 12.3289 6.03078 12.3769 6.18554 12.3769C6.3403 12.3769 6.49125 12.3289 6.61758 12.2395C6.74392 12.1501 6.83942 12.0238 6.89091 11.8778L7.50691 9.98443C7.6989 9.40909 8.02228 8.88637 8.4514 8.45772C8.88053 8.02908 9.4036 7.70628 9.97916 7.51493L11.8739 6.89893C12.0194 6.84715 12.1453 6.75162 12.2343 6.62545C12.3233 6.49928 12.3711 6.34866 12.3711 6.19425C12.3711 6.03984 12.3233 5.88921 12.2343 5.76304C12.1453 5.63687 12.0194 5.54134 11.8739 5.48956L11.8354 5.47993L9.94066 4.86393C9.3651 4.67258 8.84203 4.34979 8.4129 3.92114C7.98378 3.4925 7.6604 2.96978 7.46841 2.39443L6.85379 0.501059C6.80258 0.354641 6.70712 0.227764 6.58062 0.137994C6.45412 0.0482232 6.30284 0 6.14772 0C5.99261 0 5.84133 0.0482232 5.71483 0.137994C5.58833 0.227764 5.49287 0.354641 5.44166 0.501059L4.82566 2.39443L4.81054 2.44118C4.61787 3.00219 4.29994 3.51193 3.88086 3.93172C3.46179 4.35151 2.95259 4.67031 2.39191 4.86393L0.497162 5.47993C0.351693 5.53171 0.225814 5.62724 0.1368 5.75342C0.047786 5.87959 0 6.03021 0 6.18462C0 6.33903 0.047786 6.48966 0.1368 6.61583C0.225814 6.742 0.351693 6.83753 0.497162 6.88931L2.39191 7.50531C2.96941 7.69781 3.49191 8.02231 3.92229 8.45268ZM24.748 6.87693C25.1127 6.87693 25.4624 7.0218 25.7203 7.27966C25.9782 7.53752 26.123 7.88726 26.123 8.25193V15.1269C26.123 15.4916 25.9782 15.8413 25.7203 16.0992C25.4624 16.3571 25.1127 16.5019 24.748 16.5019C24.3834 16.5019 24.0336 16.3571 23.7758 16.0992C23.5179 15.8413 23.373 15.4916 23.373 15.1269V11.5712L15.4077 19.5366C15.1498 19.7943 14.8001 19.9391 14.4355 19.9391C14.0709 19.9391 13.7213 19.7943 13.4634 19.5366L10.998 17.0712L3.72016 24.3491C3.46083 24.5995 3.11351 24.7381 2.75299 24.735C2.39246 24.7319 2.0476 24.5872 1.79266 24.3323C1.53773 24.0774 1.39312 23.7325 1.38999 23.372C1.38685 23.0115 1.52544 22.6641 1.77591 22.4048L10.0259 14.1548C10.2838 13.897 10.6334 13.7522 10.998 13.7522C11.3626 13.7522 11.7123 13.897 11.9702 14.1548L14.4355 16.6202L21.4288 9.62693H17.873C17.5084 9.62693 17.1586 9.48207 16.9008 9.22421C16.6429 8.96634 16.498 8.61661 16.498 8.25193C16.498 7.88726 16.6429 7.53752 16.9008 7.27966C17.1586 7.0218 17.5084 6.87693 17.873 6.87693H24.748ZM24.7714 21.9538L25.8247 22.2948L25.8453 22.3003C25.9059 22.3217 25.9608 22.3569 26.0056 22.403C26.0504 22.4492 26.0839 22.5051 26.1035 22.5663C26.123 22.6276 26.1282 22.6926 26.1184 22.7562C26.1087 22.8197 26.0844 22.8802 26.0474 22.9328C25.9975 23.0031 25.9268 23.056 25.8453 23.0841L24.7934 23.4251C24.4733 23.5315 24.1824 23.7111 23.9437 23.9495C23.7051 24.188 23.5252 24.4787 23.4184 24.7987L23.0774 25.8492C23.0489 25.9304 22.9959 26.0008 22.9257 26.0506C22.8555 26.1003 22.7716 26.1271 22.6855 26.1271C22.5995 26.1271 22.5155 26.1003 22.4453 26.0506C22.3751 26.0008 22.3221 25.9304 22.2937 25.8492L21.9513 24.7987C21.8452 24.4781 21.6658 24.1866 21.4273 23.9474C21.1889 23.7083 20.898 23.528 20.5777 23.4209L19.5258 23.0786C19.4651 23.0571 19.4103 23.022 19.3655 22.9758C19.3207 22.9297 19.2872 22.8738 19.2676 22.8125C19.248 22.7512 19.2429 22.6863 19.2526 22.6227C19.2624 22.5591 19.2867 22.4987 19.3237 22.4461C19.3736 22.3758 19.4443 22.3229 19.5258 22.2948L20.5777 21.9538C20.8935 21.8446 21.18 21.6639 21.4146 21.4259C21.6493 21.1879 21.8259 20.899 21.9307 20.5816L22.273 19.5297C22.3015 19.4485 22.3545 19.3781 22.4247 19.3283C22.4949 19.2785 22.5788 19.2518 22.6649 19.2518C22.751 19.2518 22.8349 19.2785 22.9051 19.3283C22.9753 19.3781 23.0283 19.4485 23.0568 19.5297L23.3992 20.5802C23.5058 20.9 23.6855 21.1907 23.9239 21.4291C24.1623 21.6675 24.4516 21.8471 24.7714 21.9538Z"
        />
      </svg>
    ),
    key: "trending",
    id: "msp-trending",
    title: "Trending",
    subtitle: "Trending",
    path: "/trending-courses",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27px"
        height="27px"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M12 3L1 9l11 6l9-4.91V17h2V9M5 13.18v4L12 21l7-3.82v-4L12 17z"
        />
      </svg>
    ),
    key: "batches",
    id: "msp-batches",
    title: "Batches",
    subtitle: "Batches",
    path: "/batches",
  },
  {
    icon: (
      <svg
        width="30"
        height="24"
        viewBox="0 0 28 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        id="resume"
      >
        <path
          opacity="0.2"
          d="M6.125 1.75H17.8238C18.1877 1.74984 18.5477 1.82537 18.8809 1.97179C19.2141 2.1182 19.5132 2.3323 19.7593 2.6005L27.3088 10.829C27.7532 11.3131 27.9998 11.9463 28 12.6035V30.625C28 31.3212 27.7234 31.9889 27.2312 32.4812C26.7389 32.9734 26.0712 33.25 25.375 33.25H6.125C5.42881 33.25 4.76113 32.9734 4.26884 32.4812C3.77656 31.9889 3.5 31.3212 3.5 30.625V4.375C3.5 3.67881 3.77656 3.01113 4.26884 2.51885C4.76113 2.02656 5.42881 1.75 6.125 1.75Z"
          fill="#FFA103"
        />
        <path
          d="M6.125 20.125C5.89294 20.125 5.67038 20.0328 5.50628 19.8687C5.34219 19.7046 5.25 19.4821 5.25 19.25C5.25 19.0179 5.34219 18.7954 5.50628 18.6313C5.67038 18.4672 5.89294 18.375 6.125 18.375H18.375C18.6071 18.375 18.8296 18.4672 18.9937 18.6313C19.1578 18.7954 19.25 19.0179 19.25 19.25C19.25 19.4821 19.1578 19.7046 18.9937 19.8687C18.8296 20.0328 18.6071 20.125 18.375 20.125H6.125ZM6.125 24.5C5.89294 24.5 5.67038 24.4078 5.50628 24.2437C5.34219 24.0796 5.25 23.8571 5.25 23.625C5.25 23.3929 5.34219 23.1704 5.50628 23.0063C5.67038 22.8422 5.89294 22.75 6.125 22.75H18.375C18.6071 22.75 18.8296 22.8422 18.9937 23.0063C19.1578 23.1704 19.25 23.3929 19.25 23.625C19.25 23.8571 19.1578 24.0796 18.9937 24.2437C18.8296 24.4078 18.6071 24.5 18.375 24.5H6.125Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3238 2.44548e-07H2.625C1.92881 2.44548e-07 1.26113 0.276562 0.768845 0.768845C0.276562 1.26113 0 1.92881 0 2.625V28.875C0 29.5712 0.276562 30.2389 0.768845 30.7312C1.26113 31.2234 1.92881 31.5 2.625 31.5H21.875C22.5712 31.5 23.2389 31.2234 23.7312 30.7312C24.2234 30.2389 24.5 29.5712 24.5 28.875V10.8535C24.4998 10.1963 24.2532 9.56312 23.8088 9.079L16.2593 0.8505C16.0132 0.582305 15.7141 0.368201 15.3809 0.221786C15.0477 0.0753703 14.6877 -0.000156846 14.3238 2.44548e-07ZM1.75 2.625C1.75 2.39294 1.84219 2.17038 2.00628 2.00628C2.17038 1.84219 2.39294 1.75 2.625 1.75H14.3238C14.4452 1.74987 14.5653 1.775 14.6765 1.82381C14.7876 1.87262 14.8874 1.94403 14.9695 2.0335L22.519 10.262C22.6674 10.4233 22.7498 10.6344 22.75 10.8535V28.875C22.75 29.1071 22.6578 29.3296 22.4937 29.4937C22.3296 29.6578 22.1071 29.75 21.875 29.75H2.625C2.39294 29.75 2.17038 29.6578 2.00628 29.4937C1.84219 29.3296 1.75 29.1071 1.75 28.875V2.625Z"
          fill="currentColor"
        />
        <path
          d="M14.875 1.9248V10.1498H23.1"
          stroke="currentColor"
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.98453 8.98265C9.23444 8.9903 9.48333 8.94769 9.71646 8.85734C9.94958 8.76699 10.1622 8.63074 10.3417 8.45667C10.5211 8.28261 10.6638 8.07427 10.7613 7.84402C10.8587 7.61377 10.9089 7.3663 10.9089 7.11627C10.9089 6.86625 10.8587 6.61878 10.7613 6.38853C10.6638 6.15827 10.5211 5.94994 10.3417 5.77587C10.1622 5.60181 9.94958 5.46556 9.71646 5.37521C9.48333 5.28486 9.23444 5.24225 8.98453 5.2499C8.49943 5.26475 8.03917 5.4679 7.70129 5.81629C7.3634 6.16469 7.17444 6.63095 7.17444 7.11627C7.17444 7.6016 7.3634 8.06786 7.70129 8.41625C8.03917 8.76465 8.49943 8.96779 8.98453 8.98265Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7155 13.0272C12.7155 11.0427 11.0443 9.60596 8.98275 9.60596C6.92125 9.60596 5.25 11.041 5.25 13.0272V13.9617C5.25046 14.1266 5.3163 14.2846 5.43309 14.4011C5.54987 14.5176 5.70807 14.583 5.873 14.583H12.0943C12.2589 14.5825 12.4166 14.5169 12.533 14.4005C12.6494 14.2841 12.715 14.1263 12.7155 13.9617V13.0272Z"
          fill="currentColor"
        />
      </svg>
    ),
    key: "resume-builder",
    id: "msp-resume",
    title: "Resume",
    subtitle: "Resume",
    path: "/resume-builder",
  },
];

export const batchItems = [
  {
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 28 20"
        fill="none"
        className="hamburuer"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 18.3333C0 19.2538 0.746191 20 1.66667 20H12.3333C13.2538 20 14 19.2538 14 18.3333C14 17.4129 13.2538 16.6667 12.3333 16.6667H1.66667C0.746191 16.6667 0 17.4129 0 18.3333ZM0 10C0 10.9205 0.746191 11.6667 1.66667 11.6667H26.3333C27.2538 11.6667 28 10.9205 28 10C28 9.07952 27.2538 8.33333 26.3333 8.33333H1.66667C0.746193 8.33333 0 9.07952 0 10ZM0 1.66667C0 2.58714 0.746191 3.33333 1.66667 3.33333H26.3333C27.2538 3.33333 28 2.58714 28 1.66667C28 0.746192 27.2538 0 26.3333 0L1.66667 0C0.746193 0 0 0.746192 0 1.66667Z"
          fill="currentColor"
        />
      </svg>
    ),
    id: "msp-home",
    title: "",
    subtitle: "",
    path: "/",
    path2: "/",
  },
  {
    icon: (
      <svg
        width="27px"
        height="27px"
        viewBox="0 0 28 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="sidebar-icon"
      >
        <path
          d="M27.4205 13.1638L14.6986 0.392491C14.607 0.300287 14.4982 0.227136 14.3784 0.177225C14.2586 0.127314 14.1302 0.101624 14.0006 0.101624C13.8709 0.101624 13.7425 0.127314 13.6227 0.177225C13.503 0.227136 13.3942 0.300287 13.3026 0.392491L0.580655 13.1638C0.210024 13.5362 0 14.042 0 14.5694C0 15.6648 0.886425 16.5553 1.9767 16.5553H3.31715V25.6684C3.31715 26.2176 3.75881 26.6613 4.30549 26.6613H12.0239V19.7109H15.4831V26.6613H23.6957C24.2423 26.6613 24.684 26.2176 24.684 25.6684V16.5553H26.0245C26.5495 16.5553 27.053 16.3474 27.4236 15.9719C28.1926 15.1962 28.1926 13.9396 27.4205 13.1638Z"
          fill="currentColor"
        />
      </svg>
    ),
    id: "msp-home",
    title: "Home",
    subtitle: "Home",
    path: "",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27px"
        height="27px"
        viewBox="0 0 24 24"
        className="sidebar-icon"
      >
        <path
          fill="currentColor"
          d="M19 18H9a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1v5l2-1.5L14 7V2h5a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2m-2 2v2H5a2 2 0 0 1-2-2V6h2v14z"
        />
      </svg>
    ),
    id: "msp-syllabus",
    title: "Syllabus",
    subtitle: "Syllabus",
    path: "syllabus",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27px"
        height="27px"
        viewBox="0 0 24 24"
        className="sidebar-icon"
      >
        <path
          fill="currentColor"
          d="M2 19c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-8H2zM19 4h-2V3c0-.6-.4-1-1-1s-1 .4-1 1v1H9V3c0-.6-.4-1-1-1s-1 .4-1 1v1H5C3.3 4 2 5.3 2 7v2h20V7c0-1.7-1.3-3-3-3"
        />
      </svg>
    ),
    id: "msp-calender",
    title: "Calendar",
    subtitle: "Calendar",
    path: "calendar",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <path
          fill="currentColor"
          d="M5.25 4A3.25 3.25 0 0 0 2 7.25v7.92a7 7 0 0 1 11.5 7.938V25h13.25A3.25 3.25 0 0 0 30 21.75V7.25A3.25 3.25 0 0 0 26.75 4zM9 10h14a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2m7 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m-3 1.5a5.5 5.5 0 1 1-11 0a5.5 5.5 0 0 1 11 0m-1 5.362A6.97 6.97 0 0 1 7.5 26.5A6.97 6.97 0 0 1 3 24.862V29a1 1 0 0 0 1.528.849l2.972-1.85l2.972 1.85a1 1 0 0 0 1.528-.85z"
        />
      </svg>
    ),
    id: "msp-certificate",
    title: "Certificate",
    subtitle: "Certificate",
    path: "certificate",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        className="sidebar-icon"
      >
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M2.5 6c0-1.54 0-2.31.347-2.876c.194-.317.46-.583.777-.777C4.189 2 4.96 2 6.5 2s2.31 0 2.876.347c.317.194.583.46.777.777c.347.565.347 1.336.347 2.876s0 2.31-.347 2.876c-.194.317-.46.583-.777.777C8.811 10 8.04 10 6.5 10s-2.31 0-2.876-.347a2.35 2.35 0 0 1-.777-.777C2.5 8.311 2.5 7.54 2.5 6m1.282 8.782c1.047-1.047 1.57-1.57 2.19-1.72a2.26 2.26 0 0 1 1.056 0c.62.15 1.143.673 2.19 1.72s1.57 1.57 1.72 2.19a2.3 2.3 0 0 1 0 1.056c-.15.62-.673 1.144-1.72 2.19s-1.57 1.57-2.19 1.72a2.26 2.26 0 0 1-1.056 0c-.62-.15-1.143-.673-2.19-1.72s-1.57-1.57-1.72-2.19a2.26 2.26 0 0 1 0-1.056c.15-.62.673-1.144 1.72-2.19M14 18c0-1.54 0-2.31.347-2.876c.194-.317.46-.583.777-.777C15.689 14 16.46 14 18 14s2.31 0 2.877.347c.316.194.582.46.776.777C22 15.689 22 16.46 22 18s0 2.31-.347 2.877a2.36 2.36 0 0 1-.776.776C20.31 22 19.54 22 18 22s-2.31 0-2.876-.347a2.35 2.35 0 0 1-.777-.776C14 20.31 14 19.54 14 18m4-16v8m4-4h-8"
          color="currentColor"
        />
      </svg>
    ),
    id: "msp-test",
    title: "Tests",
    subtitle: "Tests",
    path: "test",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        className="sidebar-icon"
      >
        <path
          fill="currentColor"
          d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h4.2q.325-.9 1.088-1.45T12 1t1.713.55T14.8 3H19q.825 0 1.413.588T21 5v14q0 .825-.587 1.413T19 21zm2-4h7v-2H7zm0-4h10v-2H7zm0-4h10V7H7zm5-4.75q.325 0 .538-.213t.212-.537t-.213-.537T12 2.75t-.537.213t-.213.537t.213.538t.537.212"
        />
      </svg>
    ),
    id: "msp-assignments",
    title: "Questions",
    subtitle: "Questions",
    path: "questions",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={28}
        height={28}
        viewBox="0 0 28 28"
      >
        <path
          fill="currentColor"
          d="M6.75 3H17v22H6.75A3.75 3.75 0 0 1 3 21.25V6.75A3.75 3.75 0 0 1 6.75 3M18.5 17v-6H25v6zm0 8v-6.5H25v2.75A3.75 3.75 0 0 1 21.25 25zm0-22v6.5H25V6.75A3.75 3.75 0 0 0 21.25 3zM7.75 7.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25zM8 12V9h4.5v3zm-1.5 4.25c0 .414.336.75.75.75h6a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 0-.75.75M7.25 19a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z"
        ></path>
      </svg>
    ),
    id: "msp-contents",
    title: "Contents",
    subtitle: "Contents",
    path: "contents",
  },
];
